<template>
  <v-card>
    <v-card-actions class="justify-end" :style="{ flexWrap: 'wrap' }">
      <v-switch
        v-model="isActive"
        :loading="isActiveLoading"
        hide-details
        color="primary"
        class="mt-0"
        @change="handleActiveChange"
      />
      <v-btn icon flat class="ma-0" @click="$emit('edit')">
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn icon flat color="error" class="ma-0" @click="$emit('delete')">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-title class="title">{{ value.branch_name || '-' }}</v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1">
          <label class="d-block">{{ $t('phone no.') }}</label>
          <p class="ma-0">{{ value.phone_number || '-' }}</p>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <label class="d-block">{{ $t('Address') }}</label>
          <p class="ma-0">{{ value.address_string || '-' }}</p>
        </v-flex>
        <v-flex xs12 class="pa-1">
          <label class="d-block">Google Map</label>
          <p class="ma-0">{{ value.link_google_map || '-' }}</p>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <label class="d-block">{{ $t('latitude') }}</label>
          <p class="ma-0">{{ value.latitude || '-' }}</p>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <label class="d-block">{{ $t('longitude') }}</label>
          <p class="ma-0">{{ value.longitude || '-' }}</p>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      isActive: this.value.is_used,
      isActiveLoading: false
    }
  },
  watch: {
    active(value) {
      this.isActive = value
    }
  },
  methods: {
    handleActiveChange(value) {
      const setIsActive = (active) => {
        this.isActive = active
      }
      const setIsActiveLoading = (loading) => {
        this.isActiveLoading = loading
      }
      this.$emit('activeChange', this.value, value, { setIsActive, setIsActiveLoading })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/Item.vue